import { store } from '~/store';
import { EditRouteHistoryApi } from '~/api/EditRouteHistoryApi';
import { setEditHistoryByClient } from '~/reducers/editHistoryByClientSlice';
import { setEditHistoryMetrics } from '~/reducers/editHistoryMetricsSlice';
import { queryClient } from '~/queryClient';
import { REACT_QUERY_KEY as EDIT_HISTORY_QUERY_KEY } from '~/hooks/useGetEditHistory';
import { REACT_QUERY_KEY as EDIT_HISTORY_METRICS_QUERY_KEY } from '~/hooks/useGetEditRouteHistoryMetrics';

async function addMetricsToStore(clientId, schedulerTaskId) {
    if (!clientId) {
        return Promise.reject('missing clientId');
    }
    if (!schedulerTaskId) {
        return Promise.reject('missing schedulerTaskId');
    }
    try {
        const editHistory = await EditRouteHistoryApi.getEditHistory(
            clientId,
            schedulerTaskId
        );
        const editHistoryData = editHistory.data.data;
        store.dispatch(
            setEditHistoryByClient({
                clientId,
                data: editHistoryData
            })
        );
        queryClient.setQueryData(
            [EDIT_HISTORY_QUERY_KEY, clientId, schedulerTaskId],
            editHistoryData
        );

        const editHistoryMetrics = await EditRouteHistoryApi.getMetrics(
            clientId,
            schedulerTaskId
        );
        const {
            data: { data }
        } = editHistoryMetrics;
        store.dispatch(setEditHistoryMetrics(data));
        queryClient.setQueryData(
            [EDIT_HISTORY_METRICS_QUERY_KEY, clientId, schedulerTaskId],
            data
        );
    } catch (e) {
        console.warn(e);
    }
}

export const planEditMetricsService = {
    addMetricsToStore
};
